import queryCurrentUser from '@ms/yammer-graphql/dist/operations/queryCurrentUser.graphql';

const apiName = 'CurrentUserClients';

const apiRequestBody = {
  operationName: apiName,
  query: queryCurrentUser,
};

export const getCacheKey = () => apiName.concat(JSON.stringify(apiRequestBody));
